import { List } from 'immutable'
import { checkStatus, json, CustomerAPI, ConversationAPI } from '@driftt/dapper'
import { Tag } from './models'

function parseTags(data) {
  return List(data).map(Tag)
}

export const api = {
  fetchList(orgId) {
    return CustomerAPI.get(`/organizations/${orgId}/tags`)
      .then(checkStatus)
      .then(json)
      .then(parseTags)
  },

  create(orgId, tag) {
    return CustomerAPI.post(`/organizations/${orgId}/tags`, tag.toJS())
      .then(checkStatus)
      .then(json)
      .then(Tag)
  },

  update(orgId, tag) {
    return CustomerAPI.patch(`/organizations/${orgId}/tags/${tag.id}`, tag.toJS())
      .then(checkStatus)
      .then(json)
      .then(Tag)
  },

  ['delete'](orgId, tagId) {
    return CustomerAPI.delete(`/organizations/${orgId}/tags/${tagId}`)
      .then(checkStatus)
  },

  tagConversation(conversationId, tagIds) {
    return ConversationAPI.post(`/conversations/${conversationId}/tags`, tagIds)
      .then(checkStatus)
  },

  untagConversation(conversationId, tagIds) {
    return ConversationAPI.delete(`/conversations/${conversationId}/tags`, tagIds)
      .then(checkStatus)
  },

  tagCompany(companyId, tagIds) {
    return CustomerAPI.post(`/companies/${companyId}/tags`, tagIds)
      .then(checkStatus)
  },

  untagCompany(companyId, tagIds) {
    return CustomerAPI.delete(`/companies/${companyId}/tags`, tagIds)
      .then(checkStatus)
  },

  tagEndUser(endUserId, tagIds) {
    return CustomerAPI.post(`/end_users/${endUserId}/tags`, tagIds)
      .then(checkStatus)
  },

  untagEndUser(endUserId, tagIds) {
    return CustomerAPI.delete(`/end_users/${endUserId}/tags`, tagIds)
      .then(checkStatus)
  },

  setResponseTags(responseId, tagIds) {
    return CustomerAPI.patch(`/interactions/responses/${responseId}/tags`, tagIds)
      .then(checkStatus)
      .then(json)
      .then(data => parseTags(data.tags))
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/tags/api.js